import React from 'react'

import SignUpInput from './SignUpInput'
import Grid from '../../../../components/Grid'
import Icon, { EIconId } from '../../../../components/icons'
import ClientApi from '../../../../api/clientApi'
import { validateEmail } from '../../utils'
import { newsletterSubscriptionRequestEvent } from '../../../../utils/gtm'

import { content } from './data'

import ELocale from '../../../../types/locales'
import trackEvent from '../../../../utils/gtm/trackEvent'
import { getEecPromoClickEventForNewsletter } from '../../../../utils/gtm/eecPromoClickEvents'

const SignUpForm: React.FC<{ locale: ELocale }> = (props) => {
  const [inputValue, setInputValue] = React.useState<string>('')
  const [isValidEmail, setIsValidEmail] = React.useState<boolean | null>(null)
  const [isSuccessful, setIsSuccessful] = React.useState<boolean | null>(null)
  const [hasFocus, setHasFocus] = React.useState<boolean | null>(null)

  const hasError = isValidEmail === false || isSuccessful === false

  React.useEffect(() => {
    let apiCallCancelled = false
    const subscribe = async () => {
      await ClientApi.createNewsletterSubscription(inputValue)
      if (!apiCallCancelled) {
        setIsSuccessful(true)
        newsletterSubscriptionRequestEvent()
        trackEvent(getEecPromoClickEventForNewsletter(window.location.pathname))
      }
    }
    try {
      if (isValidEmail === true) {
        subscribe()
      }
    } catch (e) {
      console.error(e)
      if (!apiCallCancelled) {
        setIsSuccessful(false)
      }
    }
    return () => {
      apiCallCancelled = true
    }
  }, [isValidEmail, inputValue])

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.currentTarget.value)
  }

  const handleOnSubmit = () => {
    setIsValidEmail(validateEmail(inputValue))
  }

  const handleOnFocus = () => {
    setHasFocus(true)
  }

  const handleOnBlur = () => {
    setHasFocus(false)
  }

  if (isSuccessful) {
    return <p className="text-iron text-center sm:text-left">{content.success}</p>
  }

  return (
    <Grid.Row>
      <Grid.Col width={12} className="md:w-auto md:flex-1">
        <SignUpInput
          name={'mail'}
          value={inputValue}
          hasError={hasError}
          hasFocus={!!hasFocus}
          onChange={handleOnChange}
          onFocus={handleOnFocus}
          onBlur={handleOnBlur}
        />
        {isValidEmail === false && <ErrorMessage label={content.invalid} />}
        {isSuccessful === false && <ErrorMessage label={content.fail} />}
      </Grid.Col>
      <Grid.Col width={12} className="mt-16 md:mt-0 md:w-auto md:ml-16">
        <button
          className="h-48 w-full sm:w-auto px-48 text-white font-bold cursor-pointer outline-none bg-brand-orange"
          onClick={handleOnSubmit}
          data-button-type="primary"
        >
          Anmelden
        </button>
      </Grid.Col>
      <Grid.Col as="p" width={12} className="text-iron text-14 text-center sm:text-left mt-8">
        Es gilt die{' '}
        <a
          className="underline"
          href={content.dataProtection.url[props.locale]}
          target="_blank"
          rel="noopener noreferrer"
        >
          Datenschutzrichtlinie
        </a>
      </Grid.Col>
    </Grid.Row>
  )
}

const ErrorMessage: React.FC<{ label: string }> = (props) => (
  <div className="flex text-sale-red mt-16">
    <Icon id={EIconId.EXCLAMATORY_MARK} className="w-24 mr-8 flex-none -mt-2" clear={true} />
    {props.label}
  </div>
)

export { SignUpForm as default, ErrorMessage }
